import React, { Component } from 'react'
import StyledNavbar from '../../components/StyledNavbar';
export default class Header extends Component {
  render() {
    return (
      
      <StyledNavbar />
     
    )
  }
}
